import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {NotebookContent as Component} from './NotebookContent';

function mapStateToProps(state) {
  return {
    title: getTitle(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const NotebookContent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

// Reseelect Methods
const getCurrentSection = ({notebook}) => notebook.currentSection;

const getTitle = createSelector(
  [getCurrentSection],
  (currentSection) => currentSection.title
);
